export const DYNAMIC_CLIENT_NB_TRANSACTIONS_CATMAN_KPIS = [
    'cardholder_nb_transactions_lost_in_brand_only_previous',
    'cardholder_nb_transactions_lost_in_category_for_you_previous',
    'cardholder_nb_transactions_lost_to_category_all_competitors_previous',
    'cardholder_nb_transactions_new_in_brand_only',
    'cardholder_nb_transactions_new_in_category_for_you',
    'cardholder_nb_transactions_new_to_category_all_competitors',
    'cardholder_nb_transactions_by_movement',
    'cardholder_nb_transactions_by_movement_evolution'
];
export const DYNAMIC_CLIENT_NB_TRANSACTIONS_KPI_DISPLAY_NAME = [
    'dynamic_client_cardholder_nb_transactions_lost_in_brand_only_previous',
    'dynamic_client_cardholder_nb_transactions_lost_in_category_for_you_previous',
    'dynamic_client_cardholder_nb_transactions_lost_to_category_all_competitors_previous',
    'dynamic_client_cardholder_nb_transactions_new_in_brand_only',
    'dynamic_client_cardholder_nb_transactions_new_in_category_for_you',
    'dynamic_client_cardholder_nb_transactions_new_to_category_all_competitors',
    'cardholder_nb_transactions_by_movement',
    'cardholder_nb_transactions_by_movement_comparison',
    'cardholder_nb_transactions_by_movement_benchmark'
];
export const DYNAMIC_CLIENT_NB_TRANSACTIONS_KPI_MAPPING = {
    dynamic_client_cardholder_nb_transactions_lost_in_brand_only_previous: 'cardholder_nb_transactions_lost_in_brand_only_previous',
    dynamic_client_cardholder_nb_transactions_lost_in_category_for_you_previous: 'cardholder_nb_transactions_lost_in_category_for_you_previous',
    dynamic_client_cardholder_nb_transactions_lost_to_category_all_competitors_previous: 'cardholder_nb_transactions_lost_to_category_all_competitors_previous',
    dynamic_client_cardholder_nb_transactions_new_in_brand_only: 'cardholder_nb_transactions_new_in_brand_only',
    dynamic_client_cardholder_nb_transactions_new_in_category_for_you: 'cardholder_nb_transactions_new_in_category_for_you',
    dynamic_client_cardholder_nb_transactions_new_to_category_all_competitors: 'cardholder_nb_transactions_new_to_category_all_competitors',
    cardholder_nb_transactions_by_movement: 'cardholder_nb_transactions_by_movement',
    cardholder_nb_transactions_by_movement_comparison: 'cardholder_nb_transactions_by_movement_evolution',
    cardholder_nb_transactions_by_movement_benchmark: 'cardholder_nb_transactions_evolution'
};
export const DYNAMIC_CLIENT_NB_TRANSACTIONS_DATA_TABLE_KPI_DISPLAY_NAME = [
    'cardholder_nb_transactions_by_movement',
    'cardholder_nb_transactions_by_movement_benchmark'
];
//# sourceMappingURL=nbTransactions.kpis.js.map